import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

let relativeTime = require('dayjs/plugin/relativeTime')

dayjs.extend(relativeTime).locale('pt-br')

Vue.mixin({
	methods: {
		today: date => dayjs(date).format('DD-MM'),
		year: () => dayjs().year(),
		toUTC: date => dayjs(date).utc(),
		format: date => dayjs(date).utc().format('DD/MM/YYYY'),
		hour: date => dayjs(date).format('HH:mm'),
		timeTo: date => dayjs().to(dayjs(date)),
		dayTo: date => dayjs(date).get('day'),
		timeFrom: date => dayjs().from(dayjs(date)),
		dateEnBr: date => date.split('-').reverse().join('/')
	}
})
